export default __webpack_public_path__ + "static/media/paypal2.931365f9.png";